import { useEffect, useState } from "react";
import "./Onboarding.scss";
import { Typography, Image, Card, Col, Row, Flex, Alert } from "antd";
import Logo from "../../assets/images/auth-logo.png";
import CustomButton from "../../components/CustomButton/Button";
import { getQuestionnaire, addUserQuestion } from "../../redux/slices/OnboardingSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/CustomLoader/Loader";
import { getUserDetails } from "../../redux/slices/AuthSlice";
import { BTN_TXT } from "../../constants/constants";

const { Title } = Typography;

const Onboarding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedOptions, setSelectedOptions] = useState({});
  const { questionsData, loading, qtnSubmitError, qtnSubmitLoading } = useSelector((state) => state.questionnaire);
  const { user } = useSelector((state) => state.auth);
  const isSubmitDisabled = Object.keys(selectedOptions).length === 0;


  useEffect(() => {
    dispatch(getQuestionnaire());
  }, [dispatch]);

  const handleOptionClick = (question, option) => {
    if (question.questionType === "multi-select") {
      setSelectedOptions((prev) => {
        const currentSelections = prev[question.questionId] || [];
        const isSelected = currentSelections.some(
          (item) => item.questionGroupOptionId === option.questionGroupOptionId
        );
        return {
          ...prev,
          [question.questionId]: isSelected
            ? currentSelections.filter(
              (item) => item.questionGroupOptionId !== option.questionGroupOptionId
            )
            : [
              ...currentSelections,
              {
                questionGroupId: question.questionGroupId,
                questionGroupOptionId: option.questionGroupOptionId,
                optionValue: option.optionDescription,
                optionStatus: "true",
                orgId: user?.orgId,
              },
            ],
        };
      });
    } else {
      setSelectedOptions((prev) => ({
        ...prev,
        [question.questionId]: {
          questionGroupId: question.questionGroupId,
          questionGroupOptionId: option.questionGroupOptionId,
          optionValue: option.optionDescription,
          optionStatus: "true",
          orgId: user?.orgId,
        },
      }));
    }
  };

  const handleSubmit = async () => {
    const payload = Object.values(selectedOptions).flat();
    const result = await dispatch(addUserQuestion(payload));
    if (result.payload.statusCode === 200) {
      const res = await dispatch(getUserDetails());
      if (res.payload.statusCode === 200) {
        navigate("/dashboard");
      }
    }
  };

  return (
    <div className="onboarding-container">
      <div className="logo"><Image preview={false} src={Logo} alt="Logo" /></div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Title level={1} style={{ color: "#294DD8", marginBottom: 40 }}>Tell us more about yourself</Title>
          <div className="question-container" style={{ maxHeight: "500px", overflowY: "auto", scrollbarWidth: "thin" }}>
            {questionsData?.questions?.map((question, index) => (
              <div key={question.questionId} style={{ marginBottom: 40 }}>
                <Title level={4} style={{ marginBottom: 20 }}>{`${index + 1}. ${question.questionText}`}</Title>
                <Row gutter={[16, 16]}>
                  {question.options.map((option) => (
                    <Col key={option.optionId} xs={24} sm={12} md={8}>
                      <Card
                        className={`option-card ${(question.questionType === "multi-select"
                          ? selectedOptions[question.questionId]?.some(item => item.questionGroupOptionId === option.questionGroupOptionId)
                          : selectedOptions[question.questionId]?.questionGroupOptionId === option.questionGroupOptionId
                        ) ? "selected" : ""
                          }`}
                        hoverable
                        onClick={() => handleOptionClick(question, option)}
                      >
                        {option.optionDescription}
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            ))}
            {qtnSubmitError && <Alert style={{ marginBottom: 20 }} message={qtnSubmitError} type="error" showIcon />}
            <Flex align="center" justify="flex-end" gap={10}>
              <CustomButton variant="outlined" color="primary" onClick={() => navigate("/dashboard")}>
                {BTN_TXT.SKIP}
              </CustomButton>
              <CustomButton variant="solid" color="primary" loading={qtnSubmitLoading} disabled={isSubmitDisabled} onClick={handleSubmit}>
                {BTN_TXT.SUBMIT}
              </CustomButton>
            </Flex>
          </div>
        </>
      )}
    </div>
  );
};

export default Onboarding;
